// extracted by mini-css-extract-plugin
export default {"lead":"Judges_lead__Fe-po","sub-title":"Judges_sub-title__bzG4W"};